import { React, useState, useEffect, useRef } from "react";
import {
  getControlField,
  getField,
  getSurveyList
} from "../../../../Services/tooltipService";
import { Dialog } from "primereact/dialog";
import { InputIcon } from "primereact/inputicon";
import DataTable from "../../../../Components/UiComponents/DataTable";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { approveClient } from "../../../../Services/clientService";
import { surveyApprovedStatus } from "../../../../Services/tooltipService";
import TextareaElement from "../../../../Components/UiComponents/TextareaElement";
import { surveyRejectMail } from "../../../../Services/tooltipService";
import { getCustomerControlField } from "../../../../Services/customerServices";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearchBar";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import SingleSelectElement from "../../../../Components/UiComponents/SingleSelectElement";
import { useNavigate } from "react-router-dom";

const DataSubmitted = () => {
  const toastRef = useRef();
  const [userId, serUserId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [projectModule, setProjectModule] = useState([]);
  const [surveyList, setSurveyList] = useState([]);
  const [surveyInfo, setSurveyInfo] = useState([]);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmRejectModal, setShowConfirmRejectModal] = useState(false);
  const [filteredSurveyList, setFilteredSurveyList] = useState([]); // State to hold filtered survey list
  const [searchText, setSearchText] = useState("");
  const [rejectionComment, setRejectionComment] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedLength, setSearchedLength] = useState(0);
	const [loading, setLoading] = useState(false);
  const [displayDetails,setDisplayDetails] = useState(null)
  const navigate = useNavigate()

  const handleTextareaChange = (e) => {
    setRejectionComment(e.target.value);
  };

  const handleRejectConfirm = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      const response = await surveyRejectMail(
        selectedSurvey._id,
        rejectionComment
      );

      if (response && response.data.success) {
        toastRef.current.showToast({
          type: 'success',
          message: "Survey Rejected successfully"
        });
      } else {
        toastRef.current.showToast({
          type: 'error',
          message: "Failed to fetch customer data"
        });
      }
      setShowConfirmRejectModal(false);
      getControlFields()
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  // Function to fetch and set customer control fields data
  const getCustomerControl = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      // Check if customerId is available
      if (customerId !== null) {
          // Fetch customer control field data
          const customerData = await getCustomerControlField(customerId);
          // Extract and set customer control fields
          const controlFields = customerData?.data?.cust[0].modules[0].tabs[20];
          setCustomerControlFields(controlFields);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const approveSurvey = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      setDisplayDetails(null)
      setSelectedClient("")
      setSelectedProject("")

      const response = await approveClient(customerId, selectedSurvey.clients);
      if (response && response?.status === 200) {
        toastRef.current.showToast({
          type: "success",
          message: `Survey Submitted Successfully`,
        });
      }
      setShowModal(false);

      const tooltipResponse = await surveyApprovedStatus(selectedSurvey._id);
      if (tooltipResponse && tooltipResponse?.status === 200) {
        toastRef.current.showToast({
          type: "success",
          message: `Data Collection approved Email Sent"`,
        });
      } else {
        toastRef.current.showToast({
          type: "error",
          message: `Mail sending Failed"`,
        });
      }
      getControlFields()
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const surveyRejectMailComment = async () => {
    setDisplayDetails(null)
    setSelectedClient("")
    setSelectedProject("")
    setShowModal(false);
    setShowConfirmRejectModal(true);
  };

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");
    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);

      // Extracting customer information from end user data
      const customer = enduser.customer;
      serUserId(enduser.userid);

      // Setting customer ID state
      setCustomerId(customer);
    } else {
      // Logging if no end user data found in local storage
      navigate("/login")
    localStorage.clear()
    }

    // getFieldConfig();
    getControlFields();
    getCustomerControl();
  }, [customerId]);

  const approverTemplate = (rowData) => {
    const iconColor = rowData.option_status === "true" ? "#2A9235" : "#19486B";

    return (
      <div>
        <InputIcon
          className={
            rowData.option_status === "true" ? "pi pi-eye" : "pi pi-eye"
          }
          style={{ color: iconColor }}
          onClick={() => openSurveyModal(rowData)}
        />
      </div>
    );
  };

  const valueTemplate = (rowData) => {
    if(rowData.multiDropdownValue){
      if (rowData?.multiDropdownValue?.length === 0) {
        if (rowData.value.length > 30) {
          return (
            <span>
              {rowData.value.substring(0, 30)}
              <span
                title={rowData.value}
                className="fs-13 pointer"
              >
                ...
              </span>
            </span>
          );
        } else {
          return rowData.value;
        }
      } else {
        if (rowData?.multiDropdownValue[0]?.label.length > 30) {
          return (
            <span>
              {rowData?.multiDropdownValue[0]?.label.substring(0, 30)}
              <span
                title={rowData?.multiDropdownValue[0]?.label}
                className="fs-13 pointer"
              >
                ...
              </span>
            </span>
          );
        } else {
          return rowData?.multiDropdownValue[0]?.label;
        }
      }
    }else{
    return rowData.value
    }
   
  };

  const columns = [
    {
      field: "survey_name",
      header: "Survey Name",
      style: { width: "30%" },
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "userName",
      header: "Submitted By",
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "submitted_at",
      header: "Submitted Date",
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "action",
      header: "Action",
      body: approverTemplate,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const surveyColumns = [
    {
      field: "label",
      header: "Field Name",
      style: { width: "50%" },
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "value",
      header: "Value",
      body: valueTemplate,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];
  const [fieldData, setFieldData] = useState(null)
  const [moduleData, setModuleData] = useState([])

  const getControlFields = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      if (customerId !== null) {
        const response = await getControlField(customerId);
        const getFieldResponse = await getField(customerId)
        setModuleData(getFieldResponse?.data?.cust[0].modules)
        setFieldData(getFieldResponse?.data)
        let data = response?.data;
        const customer = data.cust[0];
        const controlPanelModule = customer.modules.find(
          (module) => module.module_name === "Control Panel"
        );
        if (controlPanelModule) {
          const dataCollectionTab = controlPanelModule.tabs.find(
            (tab) => tab.tab_name === "Data Collection Submitted"
          );
          if (dataCollectionTab) {
            // Logic to rename header_name to header
            if (
              dataCollectionTab.tables.length > 0 &&
              dataCollectionTab.tables[0].headers
            ) {
              const surveyInfo = response.data.surveyInfo;
              const data1 = await getSurveyList(userId);
              setSurveyList(data1?.data?.surveyInfo);
              setFilteredSurveyList(surveyInfo);
              setSurveyInfo(data1?.data);
            }
            setProjectModule(dataCollectionTab.tables[0].headers);
          }
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const openSurveyModal = (rowData) => {
    rowData.clients = rowData.clients.map((client) => {
      if (!client.client_plan_section_new) {
        client.client_plan_section_new = [{}];
      }
      return client;
    });

    setSelectedSurvey(rowData);
    setShowModal(true);
  };

  const hideConfirmRejectModal = () => {
    setShowConfirmRejectModal(false);
  };

  const onHideModal = () => {
    setDisplayDetails(null)
    setSelectedClient("")
    setSelectedProject("")
    setShowModal(false);
  };

  // Function to handle search input change
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filteredData = surveyList.filter(
      (item) =>
        item.survey_name.toLowerCase().includes(value) ||
        item.userName.toLowerCase().includes(value) ||
        item.submitted_at.toLowerCase().includes(value)
    );

    setFilteredSurveyList(filteredData);
  };


  /**
    * Filters the customer reference data based on the provided query.
    * If the query is empty, it retrieves the full customer field data.
    * 
    * @param {string} query - The search query to filter the customer reference data.
    */
  const filteredQuestionsArray = (query) => {
    // Check if the query is not empty
    if (query.length > 0) {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        // Filter the customer reference data
        const filteredData = surveyList.filter(item => {
            // Check if any value in the item includes the query string
            return Object.values(item).some(value =>
                value.toString().toLowerCase().includes(lowerCaseQuery)
            );
        });

        // Update the state with the filtered data
        setSurveyList(filteredData);
        
    } else {
        // If the query is empty, retrieve the full customer field data
        
        getControlFields();
    }
};

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    filteredQuestionsArray(e.target.value);
  };

  const handleClearFilter = () => {
    setSearchQuery("");
    filteredQuestionsArray("");
    getControlFields();
  };

  const renderFooter = (a) => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="Reject"
            className="cancel-new-button"
            onClick={surveyRejectMailComment}
          />
          <ButtonElement
            type="submit"
            label="Approve"
            className="save-button"
            onClick={approveSurvey}
          />
        </div>
      </div>
    );
  };

  const renderFooterRejection = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement label="No" className="cancel-new-button" onClick={hideConfirmRejectModal} />
          <ButtonElement
            type="Confirm"
            label="Yes"
            className="save-button"
            onClick={handleRejectConfirm}
          />
        </div>
      </div>
    );
  };
 
  const handleSwitch = (e) =>{
    setDisplayDetails(e.value.fields)
  }
  
  return (
    <div className="group-table-component">
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div>
        <p className="fs-16 fw-600 mar-b-3">
          {customerControlFields?.display_name}
        </p>
        <p className="group-table-text-section">
          Please approve or reject the survey forms
        </p>
      </div>

      <div>
        <Dialog
          visible={showModal}
          onHide={onHideModal}
          className="width-50vw"
          header={selectedSurvey ? selectedSurvey.survey_name : ""}
          position="right"
          footer={renderFooter()}
          draggable={false}
        >
          <div className="new-field">
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">Author:</label>
              </div>
              <div className="col pr-0">
                <label className="form-label text-left">
                  {selectedSurvey ? selectedSurvey.userName : ""}
                </label>
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                {
                  selectedSurvey && selectedSurvey.clients.length > 0 && <label className="form-label text-left">{moduleData?.find(item => item.module_name === "Clients").ESG_module_name}:</label>
                }
                {
                  selectedSurvey && selectedSurvey.projects.length > 0 && <label className="form-label text-left">{moduleData?.find(item => item.module_name === "Pipeline").ESG_module_name}:</label>
                }
              
              </div>
              <div className="col pr-0">
                <label className="form-label text-left">
                  {
                    selectedSurvey?.clients?.length >0 && <SingleSelectElement
                    id='label'
                    name="label"
                    options={(selectedSurvey?.clients != undefined && selectedSurvey?.clients.length > 0) ? selectedSurvey?.clients : []}
                    optionLabel="label"
                    value={selectedClient}
                    onChangeValue={(e) => {handleSwitch(e);setSelectedClient(e.value)}}
                    placeholder="-- Please select --"
                    maxSelectedLabels={1}
                    className="w-full"
                />
                  }
                  {selectedSurvey?.projects?.length > 0 && <SingleSelectElement
                      id='label'
                      name="label"
                      options={(selectedSurvey?.projects != undefined && selectedSurvey?.projects.length > 0) ? selectedSurvey?.projects : []}
                      optionLabel="label"
                      value={selectedProject}
                      onChangeValue={(e) => {handleSwitch(e);setSelectedProject(e.value)}}
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      className="w-full"
                  />}
                </label>
              </div>
            </div>

            <div className="form-group row align-items-center mb-0">
              <div className="col-md-4 pl-0 pt-17">
                <p className="label-text">Field(s)</p>
              </div>
            </div>
            <div>
              {
              selectedSurvey?.projects.length > 0 && displayDetails &&  <DataTable
              value={displayDetails}
              columns={surveyColumns}
              editMode="cell"
              dataKey="_id"
              isNewField={true}
            />
              }
              {
              selectedSurvey?.clients.length > 0 && displayDetails &&  <DataTable
              value={displayDetails}
              columns={surveyColumns}
              editMode="cell"
              dataKey="_id"
              isNewField={true}
            />
              }
            </div>
          </div>
        </Dialog>
      </div>

      <div>
        <Dialog
          visible={showConfirmRejectModal}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm Rejection"
          modal
          footer={renderFooterRejection}
          onHide={hideConfirmRejectModal}
          className="table-dialog width-32"
          draggable={false}
        >
          <div className="confirmation-content">
            <span className="table-description">Comments:</span>
            <div className="mt-10">
              <TextareaElement
                name="rejectionComment"
                rows={2}
                cols={50}
                defaultValue={rejectionComment}
                onTextareaChange={(e) => handleTextareaChange(e)}
                className="form-control input-sm"
                required
              />
            </div>
          </div>
        </Dialog>
      </div>

      <div className="group-table-buttons">
        <div className="delete-button"></div>
        <div className="group-table-search">
          <HeaderSearchBar
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
            onClick={handleClearFilter}
          />
        </div>
      </div>
      <div className="mt-20 data-submit">
        <DataTable
          value={surveyList}
          columns={columns}
          dataSubmitted={true}
          header={true}
        />
      </div>
    </div>
  );
};

export default DataSubmitted;
